import { Signal } from '@angular/core';
import { DataPerson } from '@shared/components/navbar/data-access';
import { IUiClientSettings } from './ui-client-settings.model';
import { PlatformFeature } from '@application/config';
import { SystemModules } from '@domains/person/user/self/data';

export enum eLanguageCode {
  PtBr = 1,
  EnUs = 2,
  EsEs = 3,
}

export const languageCodeMap: Record<eLanguageCode, string> = {
  [eLanguageCode.PtBr]: 'pt-BR',
  [eLanguageCode.EnUs]: 'en-US',
  [eLanguageCode.EsEs]: 'es-ES',
};

export const languageCodeFromLocale: Record<string, eLanguageCode> = {
  'pt-BR': eLanguageCode.PtBr,
  'en-US': eLanguageCode.EnUs,
  'es-ES': eLanguageCode.EsEs,
};

export interface IShortcutItem {
  Identifier: string;
}

export interface IDeckItem {
  Identifier: string;
  PositionX: number;
  PositionY: number;
}

export interface IValidationResult {
  IsValid: boolean;
  Errors: string[];
  RuleSetsExecuted: string | null;
}

export interface IUserSettings {
  UserSettingsId: string;
  LanguageCode: eLanguageCode;
  Decks: IDeckItem[];
  FavoriteMenus: IShortcutItem[];
  Sidebar: IShortcutItem[];
  Operation: any;
  ValidationResult: IValidationResult;
  IsValid: boolean;
  /** UI client settings stored as JSON - contains elasticSearch, sidebar preferences */
  UiClientSettings?: IUiClientSettings | string;
}

export type TShortcutState = 'default' | 'disabled';
export type TUnsavedData = {
  id?: string;
  type: EShortcutIdentifier;
  name: string;
  value: any;
  action: () => void;
};
export type TShortcutOption = {
  id: string;
  description: string;
  isChecked: boolean;
  state: TShortcutState;
  identifier: string;
  tabs?: Signal<TUnsavedData[]>;
  requiredPermissions?: number[];
  requiredPlatformFeatures?: PlatformFeature[];
  requiredModules?: SystemModules[];
  requiredAnyModules?: SystemModules[];
};

export enum EShortcutIdentifier {
  NewClient = 'new-client',
  NewSubscription = 'new-subscribe',
  LaunchService = 'launch-service',
  NewSale = 'new-sale',
  NewVisitor = 'new-visitor',
  MakePayment = 'make-payment',
  MakeReceipt = 'make-receipt',
  NewAssessment = 'new-assessment',
  Consumption = 'consumption',
  NewGraduation = 'new-graduation',
  NewPause = 'new-pause',
  NewContract = 'new-contract',
  NewEnrollment = 'new-enrollment',
}

export const shortcutsHiddenRoutes = [];

export const iconMap: Record<EShortcutIdentifier, string> = {
  [EShortcutIdentifier.NewClient]: 'circle-user',
  [EShortcutIdentifier.NewSubscription]: 'memo-circle-check',
  [EShortcutIdentifier.LaunchService]: 'heart-partner-handshake',
  [EShortcutIdentifier.NewSale]: 'box-open',
  [EShortcutIdentifier.NewVisitor]: 'id-card-clip-alt',
  [EShortcutIdentifier.MakePayment]: 'bill-arrow',
  [EShortcutIdentifier.MakeReceipt]: 'bill-arrow -scale-y-100',
  [EShortcutIdentifier.NewAssessment]: 'clipboard-check',
  [EShortcutIdentifier.Consumption]: 'bolt',
  [EShortcutIdentifier.NewGraduation]: 'graduation-cap',
  [EShortcutIdentifier.NewPause]: 'lock',
  [EShortcutIdentifier.NewContract]: 'file-signature',
  [EShortcutIdentifier.NewEnrollment]: 'id-badge',
};

export interface SuperSearchPersonParams {
  q: string;
  page?: number;
  registrationType?: string;
  isActive?: boolean;
}
export interface SuperSearchPersonResponse {
  results: DataPerson[];
  total?: number;
  page?: number;
  pages?: number;
}
